<template>
  <div v-if="loading" class="loading-overlay">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p style="margin-top: 24px">Loading...</p>
    </div>
  </div>
  <div v-else>
    <!-- Header Section -->
    <header class="bg-primary text-white text-center py-3 header-background">
      <div class="container">
        <div class="ad-content mt-4">
          <h2 class="text-uppercase fw-bold">Join Our Free WhatsApp Group!</h2>
          <div v-for="(text, index) in alertTexts" :key="index" class="alert-box">
            <span class="alert-icon" style="color: #eb7b00;">&#10148;</span>
            <span class="alert-text" v-html="text"></span>
          </div>
        </div>

        <!-- New Stock Summary Alert Box -->
        <div class="alert-box stock-summary" v-if="stockShow">
          <div class="title">{{stockSummary.stockCode}}</div>
          <div class="summary-row">
            <span class="label">Last Price:</span>
            <span class="value">{{ stockSummary.lastPrice }}</span>
          </div>
          <div class="summary-row">
            <span class="label">Volume:</span>
            <span class="value">{{ stockSummary.volume }}</span>
          </div>
          <div class="summary-row">
            <span class="label">High:</span>
            <span class="value">{{ stockSummary.high }}</span>
          </div>
          <div class="summary-row">
            <span class="label">Low:</span>
            <span class="value">{{ stockSummary.low }}</span>
          </div>
        </div>
        <button class="btn btn-success btn-lg2" @click="joinForFree">Free Stock Alerts Now</button>
      </div>
    </header>

    <!-- Featured Section -->
    <section class="text-center py-4">
      <div class="container">
        <h2 class="featured-title">
          <span class="highlight">Our picks</span> have been featured on...
        </h2>
        <div class="d-flex flex-wrap justify-content-center mt-2">
          <img v-for="(logo, index) in featuredLogos" :key="index" :src="logo.src" :alt="logo.alt" class="m-2 fixed-logo-size" />
        </div>
      </div>
    </section>

    <!-- Stock Picks Section -->
    <section class="bg-light py-3">
      <div class="container" >
        <h2 class="stock-picks-title">Most of our recent picks have seen <span class="highlight d-block text-center">significant gains!</span></h2>
        <div class="row mt-4">
          <div v-for="(stock, index) in stockPicks" :key="index" class="col-md-3 col-sm-6 mb-4">
            <div class="card">
              <img :src="stock.image" class="card-img-top" :alt="stock.alt">
              <div class="card-body">
                <h5 class="card-title">{{ stock.title }}</h5>
              </div>
            </div>
          </div>
        </div>
        <p class="disclaimer-text"> *Past performance does not guarantee future results. The investment return and principal value of an investment will fluctuate so that an investor's shares, when redeemed, may be worth more or less than the original cost, and current performance may be lower or higher than the performance quoted.</p>
      </div>
    </section>

    <!-- Testimonials Section -->
    <section class="bg-light py-3">
      <div class="container">
        <h2 class="text-center">Hear from Successful Small Cap Stock Traders Sharing Their Insights</h2>
        <div class="row mt-4">
          <div v-for="(testimonial, index) in testimonials" :key="index" class="col-md-6 col-lg-3 mb-2">
            <div class="card">
              <div class="card-body text-center">
                <img :src="testimonial.image" :alt="testimonial.alt" class="rounded-circle mb-3" width="80">
                <h5 class="card-title">{{ testimonial.name }}</h5>
                <p>{{ testimonial.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-light py-2">
      <div class="text-center">
        <button class="btn btn-success btn-lg2" @click="joinForFree">Get Your Free Stock Alerts Now</button>
        <p class="disclaimer-text" style="margin-top: 15px"> *Privacy Policy: Your privacy is important to us. We will not share your information without your consent..</p>
        <p class="disclaimer-text"> *Disclaimer: The information provided on this page is for informational purposes only and does not constitute investment advice. Always consult with a financial advisor before making any investment decisions.</p>
      </div>
    </section>

    <!-- Footer Section -->
    <footer class="bg-dark text-white footer-center">
      <div class="container">
        <p class="mb-0">© 2025 www.dktgrn.com | All Rights Reserved.</p>
      </div>
    </footer>

    <!-- Modal Dialog -->
    <div v-if="showDialog" class="modal-overlay">
      <div class="modal-content">
        <button class="modal-close" @click="closeDialog">&times;</button>
        <h2 class="modal-title">📈 Your requested report is ready!</h2>
        <p class="modal-text">
          Expert <strong class="highlight-red">Sabrina</strong> from the <strong class="highlight-red">John's Stock Investment Club</strong> has conducted an in-depth diagnostic for you, assuring you that it will greatly help you to <strong>get out of the stock dilemma</strong>.
        </p>
        <p class="modal-text">
          However, please be reminded to <strong>constantly check the messages</strong> Sabrina sends you, as she will track the stock until you are out of the woods.
        </p>
        <p class="modal-text">
          Click <strong>"Diagnose Now"</strong> to receive personalized insights and join our WhatsApp group for live updates!
        </p>
        <p class="modal-text">
          All reports are verified by the <strong>SEC</strong> and <strong>OCC</strong>. Take control of your financial journey today!
        </p>
        <button class="btn btn-primary" @click="proceedToDiagnose">📊 Diagnose Now</button>
        <button class="btn btn-secondary" @click="closeDialog">Cancel</button>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      loading: false,
      stockShow:false,
      showDialog: false,
      featuredLogos: [
        { src: '/images/cnn.webp', alt: 'Featured Logo 1' },
        { src: '/images/djones.webp', alt: 'Featured Logo 2' },
        { src: '/images/gfinance.webp', alt: 'Featured Logo 3' },
        { src: '/images/mwatch.webp', alt: 'Featured Logo 4' },
        { src: '/images/nasdaq.webp', alt: 'Featured Logo 5' },
        { src: '/images/yahoo.webp', alt: 'Featured Logo 6' }
      ],
      stockPicks: [
        { image: '/images/psrhf.png', alt: 'Stock Pick 1', title: 'ALERTED AT: $0.22| JUMPED TO: $1.17', link: '#' },
        { image: '/images/nstgq.png', alt: 'Stock Pick 2', title: 'ALERTED AT: $16.01 | JUMPED TO: $82.96', link: '#' },
        { image: '/images/bhsif.png', alt: 'Stock Pick 3', title: 'ALERTED AT: $0.01 | JUMPED TO: $0.06', link: '#' },
        { image: '/images/lbsr.png', alt: 'Stock Pick 4', title: 'ALERTED AT: $0.03 | JUMPED TO: $0.8', link: '#' }
      ],
      testimonials: [
        { image: '/images/ced.png', alt: 'Testimonial 1', name: 'David Kerr', text: '"The insider alerts provided valuable insights that greatly improved my trading experience."' },
        { image: '/images/img-2.png', alt: 'Testimonial 2', name: 'Harold Croft', text: '"This service provided timely alerts that helped me make more informed trading decisions."' },
        { image: '/images/img-3.png', alt: 'Testimonial 3', name: 'Callum Reynolds', text: '"The alerts were timely and enabled me to act promptly on market opportunities."' },
        { image: '/images/img-4.png', alt: 'Testimonial 4', name: 'Eugene Smith', text: '"I\'ve tried several services before, but none have been as reliable as Insider Penny Stock Picks."' }
      ],
      alertTexts: [
        'Get timely stock updates from NASDAQ, NYSE, and OTC markets',
        'Receive real-time alerts on short-term and swing trades',
        'Predict Future Trends with Daily Market Summaries'
      ],
      pageData:{},
      stockSummary:{
        stockCode:'',
        lastPrice: '-',
        volume: '-',
        high: '-',
        low: '-',
      }
    };
  },
  mounted() {
    this.pageLoading(); // 在组件挂载时调用
    const code = this.getCodeFromURL();
    if (code) {
      var txt2 = 'Receive real-time alerts on trades for stocks like <span style="color: #eb7b00; font-weight: bold;">' + code + '</span>';
      var txt3 = 'Predict Future Trends for <span style="color: #eb7b00; font-weight: bold;">' + code + '</span> with Daily Market Summaries';
      this.alertTexts = [
        'Get timely stock updates from NASDAQ, NYSE, and OTC markets',
        txt2,
        txt3
      ];
      this.stockSummary.stockCode = code;
      this.getStockData();
    }
  },
  methods: {
    getCodeFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('code');
    },
    closeDialog() {
      this.showDialog = false;
    },
    proceedToDiagnose() {
      this.showDialog = false;
      if (typeof window.gtag === 'function') {
        // // 调用 gtag 发送转换事件
        // window.gtag('event', 'conversion', {
        //   send_to: 'AW-16760871742/Lcd_CJn8o-QZEL62mrg-', // 替换为你的事件跟踪 ID
        // });
      } else {
        console.error('gtag function is not available!');
      }
      axios.get('https://www.dktgrn.com/prod-api/newApi/clickBtn?id=' + this.pageData.clickId)
          .then(response => {
            console.log('Successfully joined:', response.data);
          })
          .catch(error => {
            console.error('Error joining:', error);
          });
      window.location.href = this.pageData.redirectUrl;
    },
    joinForFree() {
      // this.showDialog = true;
      if (typeof window.gtag === 'function') {
        // // 调用 gtag 发送转换事件
        // window.gtag('event', 'conversion', {
        //   send_to: 'AW-16760871742/Lcd_CJn8o-QZEL62mrg-', // 替换为你的事件跟踪 ID
        // });
      } else {
        console.error('gtag function is not available!');
      }
      axios.get('https://www.dktgrn.com/prod-api/newApi/clickBtn?id=' + this.pageData.clickId)
          .then(response => {
            console.log('Successfully joined:', response.data);
          })
          .catch(error => {
            console.error('Error joining:', error);
          });
      window.location.href = this.pageData.redirectUrl;

    },
    async pageLoading() {
      try {
        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);
        params.append('region', 'US');
        const apiUrl = `https://www.dktgrn.com/prod-api/noApi/pageLoading?${params.toString()}`;
        const response = await axios.get(apiUrl);
        if(response.data.code == 200){
          this.loading = false;
          this.pageData = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching stock data:', error);
      }
    },
    async getStockData(){
      try {
        const apiUrl = 'https://www.dktgrn.com/prod-api/newApi/getAllStockData?code=' + this.stockSummary.stockCode;
        const response = await axios.get(apiUrl);
        if (response.data.code == 200) {
              this.stockSummary.volume = response.data.data.regularMarketVolume;
              this.stockSummary.high = response.data.data.regularMarketDayHigh;
              this.stockSummary.low = response.data.data.regularMarketDayLow;
              this.stockSummary.lastPrice = response.data.data.regularMarketPrice;
              this.stockShow = true;
        } else {
          console.error('Response data is missing msg field.');
        }
      } catch (error) {
        console.error('Error fetching stock data:', error);
      }
    }
  }
};
</script>

<style scoped>
  .spinner {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #007bff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .loading-spinner {
    font-size: 1.5rem;
    color: #007bff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #007bff;
  }
  .bg-light.py-5 {
    padding-top: 1rem;  /* 自定义顶部的 padding */
    padding-bottom: 1rem;  /* 自定义底部的 padding */
  }
  .bg-primary {
    background-color: #007bff !important;
  }
  .bg-light {
    background-color: #f8f9fa !important;
  }
  .bg-dark {
    background-color: #343a40 !important;
  }
  .fixed-logo-size {
    width: 150px;
    height: 100px;
    object-fit: contain;
  }

  .card-title {
    font-size: 14px;
    text-align: center;
    color: #F1631D;
  }
  .header-background {
    background-image: url('/public/images/hero-bg.png');
    background-size: cover;
    background-position: center;
  }
  .ad-content {
    margin-top: 20px;
  }
  .ad-content h2 {
    font-size: 1.8rem;
    color: #ffc107;
  }
  .ad-content p {
    font-size: 1.2rem;
    color: #ffffff;
  }
  .featured-title {
    font-size: 2rem;
    font-weight: bold;
  }
  .highlight {
    color: #ff6f61;
  }

  .btn-lg2 {
    width: 18rem;
    font-size: 1.2rem;
  }
  .stock-picks-title {
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
    color: #007bff;
  }
  /* 添加了免责声明的样式 */
  .disclaimer-text {
    font-size: 0.8rem; /* 将字体大小调小 */
    color: #6c757d;    /* 使用灰色字体，常用于提示信息 */
    line-height: 1.5;  /* 增加行高，提升可读性 */
  }

  .footer-center {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    height: 60px;            /* 设置页脚高度，可根据需要调整 */
  }

  /* 移除段落的默认外边距，辅助垂直居中 */
  .footer-center p {
    margin: 0;
    font-size: 0.7rem;
    text-align: center;
  }

  /* Styling for new content */
  .alert-box {
    background-color: #f9f9f9;
    border-radius: 10px;
    padding: 15px;
    margin: 15px 0;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
  }
  .alert-icon {
    font-size: 20px;
    margin-right: 10px;
  }
  .alert-text {
    color: #343a40;
    font-size: 16px;
    font-weight: bold;
  }

  /* 红色高亮样式 */
  .highlight-red {
    color: #dc3545; /* 红色 */
    font-weight: bold; /* 加粗 */
  }
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px; /* 添加外边距以适应较小屏幕 */
    box-sizing: border-box;
  }

  .modal-content {
    background: white;
    border-radius: 8px;
    padding: 20px;
    max-width: 90%; /* 最大宽度为视口的90% */
    width: 400px; /* 默认宽度 */
    margin: auto; /* 居中显示 */
    text-align: center;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  .modal-close {
    background: none;
    border: none;
    font-size: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  .modal-title {
    font-size: 20px;
    font-weight: bold;
    color: #003DA5;
    margin-bottom: 10px;
  }

  .modal-text {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
  }

  .btn {
    display: inline-block;
    padding: 10px 20px;
    margin: 10px 5px 0;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    text-align: center;
  }

  .btn-primary {
    background-color: #28a745;
    color: white;
    border: none;
  }

  .btn-primary:hover {
    background-color: #218838;
  }

  .btn-secondary {
    background-color: #dc3545;
    color: white;
    border: none;
  }

  .btn-secondary:hover {
    background-color: #c82333;
  }

  .stock-summary {
    background-color: #f9f9f9;
    border-radius: 10px;
    padding: 15px;
    margin: 15px 0;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    display: block; /* Override display: flex from .alert-box */
  }

  .stock-summary .title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 15px;
    color: #003DA5;
    text-align: center;
  }

  .stock-summary .summary-row {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    font-size: 1rem;
    border-bottom: 1px solid #e0e0e0;
  }

  .stock-summary .summary-row:last-child {
    border-bottom: none;
  }

  .stock-summary .label {
    text-align: left;
    font-weight: bold;
    color: #343a40;
  }

  .stock-summary .value {
    text-align: right;
    color: #007bff;
  }


</style>
